export default {"src":"/_next/static/media/menu.4ac741a9.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};